<template>
    <page title="账单查询">
        <div v-show="accountType != 0">
            <div class="form bill">
                <mt-field label="账单号码" class="mt-gap" placeholder="输入账单号码" v-model="search.billNo"></mt-field>
                <mt-cell title="账单日期" class="price-cell">
                    <mt-field placeholder="选择起使日期" readonly v-model="search.beginTime"
                              @click.native="openPicker"></mt-field>
                    至
                    <mt-field placeholder="选择终止日期" readonly v-model="search.endTime"
                              @click.native="openPicker2"></mt-field>
                    <img src="../assets/date.png" alt="" class="input-icon" style="padding-right: 10px;">
                </mt-cell>
            </div>
            <div class="padded mt-gap2">
                <mt-button type="primary" style="width: 100%;" @click.native="searchData()">查询</mt-button>
            </div>
            <div
                    v-infinite-scroll="loadMore"
                    infinite-scroll-disabled="loading"
                    infinite-scroll-immediate-check="false"
                    infinite-scroll-distance="10">
                <div class="result" v-if="initSearch&&result.length>0">
                    <p class="padded" style="color: #666;">查询结果</p>
                    <div v-for="(item, index) in result" :key="index">
                        <div class="padded info" style="box-shadow: rgb(204, 204, 204) 0 1px 1px">
                            <div class="item">
                                <p class="fl">账单号码：{{item.billNo}}</p>
                                <span class="fr"
                                      @click="showDetail(item.billNo, index)">{{detailShow==index?'收起':'详情'}}</span>
                            </div>
                            <p>账单日期：{{item.billDate}}</p>
                            <p><span>票数：{{item.votes}}</span>&emsp;&emsp;<span>件数：{{item.pcs}}</span>&emsp;&emsp;<span>重量：{{item.weight}}KG</span>
                            </p>
                            <p>账单金额：<span style="color: red;">{{item.amount}}{{item.currencyType}}</span></p>
                        </div>
                        <div class="child-info" v-show="detailShow == index">
                            <div class="child-item borderBottom2" v-for="(subItem, subIndex) in childResult"
                                 :key="subIndex">
                                <div style="padding: 0 10px;">
                                    <p style="margin-bottom: 10px;padding-bottom: 8px;" class="borderBottom">
                                        运单号码：{{subItem.waybillNo}} <span class="fr" style="color:#999;font-size: 12px;">{{subItem.sendDate}}</span>
                                    </p>
                                    <p v-if="disableFunc.indexOf('3_1_1') === -1" style="color: #666;">
                                        转单号码：{{subItem.transNo}}</p>
                                    <div style="overflow: hidden;color: #666;">
                                        <div style="display: inline-block;width: 46%;float: left;">
                                            <p>目的地：{{subItem.destName}}</p>
                                            <p>件数：{{subItem.pcs}}</p>
                                            <p>应收运费：<span
                                                    style="color: red;">{{subItem.charge}}{{item.currencyType}}</span>
                                            </p>
                                        </div>
                                        <div style="display: inline-block;width: 52%;float: left;">
                                            <p>路线：{{subItem.transType}}</p>
                                            <p>重量：{{subItem.weight}}KG</p>
                                            <p v-if="disableFunc.indexOf('3_1_1') === -1">科目：{{subItem.subject}}</p>
                                        </div>
                                    </div>
                                    <p v-if="disableFunc.indexOf('3_1_1') === -1"><span
                                            style="color: #666;">账单备注：</span>{{subItem.billRemark}}</p>
                                    <p v-if="disableFunc.indexOf('3_1_1') === -1"><span
                                            style="color: #666;">收件备注：</span>{{subItem.recRemark}}</p>
                                </div>
                            </div>
                            <div v-show="childTotal>childResult.length">
                                <p style="text-align: center;color:#26a2ff;margin-top: 10px;" @click="loadBottom">
                                    加载更多</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="initSearch&&result.length === 0">
                <p style="text-align: center;margin-top: 10px;color: #999;font-size: 14px;">没有数据</p>
            </div>
            <mt-datetime-picker
                    ref="picker"
                    v-model="datePicker"
                    type="date"
                    @confirm="handleConfirm1">
            </mt-datetime-picker>
            <mt-datetime-picker
                    ref="picker2"
                    v-model="datePicker2"
                    type="date"
                    @confirm="handleConfirm2">
            </mt-datetime-picker>
        </div>
    </page>
</template>
<script>
    export default {
        data() {
            return {
                accountType: '',
                disableFunc: [],
                companyNo: '',
                detailShow: -1,
                datePicker: '',
                datePicker2: '',
                initSearch: false,
                search: {
                    pageIndex: 1,
                    pageSize: 10,
                    billNo: '',
                    beginTime: '',
                    endTime: ''
                },
                childSearch: {
                    pageIndex: 1,
                    pageSize: 10,
                    billNo: '',
                },
                loading: false,
                childLoading: false,
                result: [],
                total: '',
                childResult: [],
                childTotal: '',
            }
        },
        created() {
            document.title = "账单查询";
            this.companyNo = this.$util.get('companyNo');
            this.accountType = this.$util.get(this.companyNo + '_userInfo').accountType;
            if (this.accountType == 0) {
                this.$toast("此功能只针对客户账号开放");
            } else {
                var date = new Date();
                var date2 = new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000);
                this.datePicker = date2;
                this.datePicker2 = date;
                this.search.beginTime = this.dateFormat(date2);
                this.search.endTime = this.dateFormat(date);
            }
        },
        methods: {
            dateFormat(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                if (month < 10) {
                    month = '0' + month;
                }
                var day = date.getDate();
                if (day < 10) {
                    day = '0' + day;
                }
                return year + '-' + month + '-' + day;
            },
            openPicker() {
                this.$refs.picker.open();
            },
            openPicker2() {
                this.$refs.picker2.open();
            },
            handleConfirm1() {
                var date = this.datePicker;
                this.search.beginTime = this.dateFormat(date);
            },
            handleConfirm2() {
                var date = this.datePicker2;
                this.search.endTime = this.dateFormat(date);
            },
            searchData() {
                if (this.loading) return false;
                this.initSearch = true;
                this.result = [];
                this.getData();
            },
            getData(pageIndex = 1, pageSize = 10) {
                this.loading = true;
                this.$indicator.open({
                    spinnerType: 'fading-circle'
                });
                this.search.pageIndex = parseInt(pageIndex);
                this.search.pageSize = parseInt(pageSize);
                this.http.send({command: 'bill/findBill', params: this.search}).then(res => {
                    this.loading = false;
                    this.$indicator.close();
                    this.total = res.data.body.totalCount;
                    this.result = this.result.concat(res.data.body.datas || []);
                }).catch(err => {
                    this.loading = false;
                    this.$indicator.close();
                })
            },
            loadMore() {
                if (this.loading) return false;
                if (this.total === this.result.length) return false;
                this.search.pageIndex++;
                this.getData(this.search.pageIndex);
            },
            showDetail(billNo, index) {
                if (this.detailShow === index) {
                    this.detailShow = -1;
                } else {
                    this.detailShow = index;
                    this.childSearch.billNo = billNo;
                    this.childResult = [];
                    this.getDetail();
                }
            },
            loadBottom() {
                if (this.childLoading) return;
                if (this.childTotal === this.childResult.length) return;
                this.childSearch.pageIndex++;
                this.getDetail(this.childSearch.pageIndex);
            },
            getDetail(pageIndex = 1, pageSize = 10) {
                this.childLoading = true;
                this.childSearch.pageIndex = parseInt(pageIndex);
                this.childSearch.pageSize = parseInt(pageSize);
                this.http.send({command: 'bill/billingDetails', params: this.childSearch}).then(res => {
                    this.childLoading = false;
                    this.childTotal = res.data.body.totalCount;
                    this.childResult = this.childResult.concat(res.data.body.datas || []);
                }).catch(err => {
                    this.childLoading = false;
                })
            }
        }
    }
</script>
<style scoped>
    .bill >>> .mint-field-core {
        text-align: right;
    }
    .bill .price-cell >>> .mint-field-core {
        text-align: center;
    }
    .bill .price-cell {
        background-image: none;
    }
</style>
<style lang="less" scoped>
    .borderBottom {
        background-image: linear-gradient(180deg, #d9d9d9, #d9d9d9 50%, transparent 50%);
        background-size: 120% 1px;
        background-repeat: no-repeat;
        background-position: bottom left;
    }
    .borderBottom2 {
        background-image: linear-gradient(180deg, #ececec, #ececec 50%, transparent 50%);
        background-size: 120% 1px;
        background-repeat: no-repeat;
        background-position: bottom left;
    }
    .result {
        margin-top: 20px;
        .info {
            background: #fff;
            margin-top: 8px;
            padding-bottom: 10px;
            .item {
                line-height: 32px;
                border-bottom: 1px solid #f4f3f3;
                padding-bottom: 5px;
                padding-top: 5px;
                margin-bottom: 5px;
                overflow: hidden;

                span {
                    color: #19a0ff;
                }
            }
            p {
                line-height: 30px;
                &.desc {
                    color: #666666;
                    font-size: 14px;
                    line-height: 24px;
                }
            }
        }
    }
    .child-info {
        margin-top: 2px;
        padding: 0 10px;
        font-size: 14px;
        .child-item {
            background-color: #fff;
            padding: 10px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/bill.vue